import React from 'react';
import { Box, Typography } from '@mui/material';

export default function MonitoringPage() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Monitoramento
      </Typography>
      <Typography color="textSecondary">
        Página de monitoramento em construção
      </Typography>
    </Box>
  );
}